import { ToggleButton } from '@mui/material';
import React from 'react';
import { SegmentedToggleGroup } from '../SegmentedToggleGroup';
import { ChartType } from '../../types';

const TYPE_LABELS: Record<ChartType, string> = {
  area: 'Area',
  line: 'Line',
  bar: 'Bar',
  pie: 'Pie',
};

export default function ChartTypeToggle({
  value,
  onChange,
  types = ['area', 'line', 'bar'],
}: {
  value: ChartType;
  onChange: (type: ChartType) => void;
  types?: ChartType[];
}) {
  return (
    <SegmentedToggleGroup
      exclusive
      size="small"
      value={value}
      onChange={(_event, next: ChartType | null) => {
        if (next) {
          onChange(next);
        }
      }}
    >
      {types.map(type => (
        <ToggleButton key={type} value={type}>
          {TYPE_LABELS[type]}
        </ToggleButton>
      ))}
    </SegmentedToggleGroup>
  );
}
